export default __webpack_public_path__ + "static/driver-spark-logo-fe54d254b96a5e330c502f4cefd14f5c.png";